import React from "react";
import { useNavigate } from "react-router-dom";

import "../../assets/css/serviciosPag.css";
import ServicioEspecializadoCard from "../servicios/serviciosEspecializados";
import ServiciosContablesCard from "../servicios/serviciosContables";
import ServiciosGeneralesCard from "../servicios/serviciosPrincipales";

import DerechoCorporativo from "../../assets/img/DerechoCorporativo.jpg";
import SolucionesControversiales from "../../assets/img/SolucionControversias.jpg";
import DerechoProcesalCivil from "../../assets/img/DerechoProcesalCivil.jpg";
import DerechoAdministrativo from "../../assets/img/DerechoAdministrativo.jpg";
import DerechoConstitucional from "../../assets/img/DerechoConstitucional.jpg";
import DerechoContractual from "../../assets/img/DerechoContractual.jpg";
import Competencia from "../../assets/img/competencia.jpg";
import Patrimonial from "../../assets/img/patrimonial.jpg";
import Creditos from "../../assets/img/creditos.jpg";
import Minero from "../../assets/img/minero.jpg";
import Procesal from "../../assets/img/procesal.jpg";
import iconCompetencia from "../../assets/svg/iconCompetencia.svg";
import iconPatrimonial from "../../assets/svg/iconPatrimonial.svg";
import iconCreditos from "../../assets/svg/iconCreditos.svg";
import iconMinero from "../../assets/svg/iconMinero.svg";
import iconProcesal from "../../assets/svg/iconProcesal.svg";
import Calendario from "../../assets/svg/Calendario.svg";
import planificar from "../../assets/svg/Planificar.svg";
import Respuesta from "../../assets/svg/Respuesta.svg";
import Mensual from "../../assets/svg/Mensual.svg";
import flechaDolar from "../../assets/svg/flechaDolar.svg";
import { ReactComponent as Palacio } from "../../assets/svg/Palacio.svg";
import { ReactComponent as Balanza } from "../../assets/svg/Balanza.svg";
import { ReactComponent as Contabilidad } from "../../assets/svg/Contabilidad.svg";

const ServiciosPag = () => {
  const navigate = useNavigate();
  const servicios = [
    {
      titulo: "DERECHO",
      subtitulo: "CORPORATIVO",
      descripcion:
        "Ofrecemos Asesoría integral para optimizar su empresa en ámbitos internos y externos, incluyendo gestión legal, administrativa y estratégica. También brindamos apoyo en Derecho Societario, adaptando su empresa a las demandas del mercado.",
      imagen: DerechoCorporativo,
    },
    {
      titulo: "SOLUCIÓN DE",
      subtitulo: "CONTROVERSIAS",
      descripcion:
        "Brindamos soluciones para la resolución de conflictos, garantizando buenas relaciones comerciales y laborales mediante negociación, conciliación y arbitraje, incluyendo compromisos y participación arbitral.",
      imagen: SolucionesControversiales,
    },
    {
      titulo: "DERECHO CIVIL Y",
      subtitulo: "PROCESAL CIVIL",
      descripcion:
        "Ofrecemos asesoría y asistencia legal en todas las instancias del Poder Judicial, abarcando materia civil y procesal civil. Elaboramos demandas, recursos y apelaciones, brindando seguimiento continuo y reportes mensuales de avance.",
      imagen: DerechoProcesalCivil,
    },
    {
      titulo: "DERECHO",
      subtitulo: "ADMINISTRATIVO",
      descripcion:
        "Le brindamos un asesoramiento integral en lo que respecta a procesos o gestiones administrativas en las Instituciones Públicas o entes del Estado tales como: Ministerios, Gobiernos Regionales y Locales, Prefectura, Universidades, entre otros.",
      imagen: DerechoAdministrativo,
    },
    {
      titulo: "DERECHO",
      subtitulo: "CONSTITUCIONAL",
      descripcion:
        "Le ofrecemos un servicio especializado para la defensa de sus Derechos Constitucionales, entablamos procesos de garantías constitucionales (Habeas Corpus, Acción de Amparo y Habeas Data), y Defensa de Intereses Difusos ante las autoridades e instancias necesarias.",
      imagen: DerechoConstitucional,
    },
    {
      titulo: "DERECHO",
      subtitulo: "CONTRACTUAL",
      descripcion:
        "Brindamos asesoría en la elaboración y ejecución de contratos, tanto convencionales como modernos, según sus necesidades. También gestionamos trámites registrales y notariales hasta su inscripción en Registros Públicos (RRPP).",
      imagen: DerechoContractual,
    },
  ];

  const serviciosEspecializados = [
    {
      titulo: "COMPETENCIA",
      subtitulo: "DERECHO DE LA",
      descripcion:
        "Este servicio le otorga una Asesoría eficaz en las Áreas de Libre Competencia, Protección al Consumidor, Competencia Desleal, Dumping y Subsidios, Acceso al Mercado, Salida del Mercado, Propiedad Intelectual e Invención y Nuevas Tecnologías.",
      imagen: Competencia,
      icon: iconCompetencia,
    },
    {
      titulo: "PATRIMONIAL",
      subtitulo: "RESTRUCTURACIÓN",
      descripcion:
        "Asesorándolo técnica y legalmente en los Procesos Transitorios, Procedimientos de Insolvencia, Concursos Preventivos, Procesos Simplificados, Procesos Conciliatorios, Reprogramación de pago a acreedores y proveedores y refinanciamiento de deudas. Diseñando para usted el mejor Plan de Reestructuración y protegiendo su patrimonio.",
      imagen: Patrimonial,
      icon: iconPatrimonial,
    },
    {
      titulo: "DE CRÉDITOS",
      subtitulo: "RECUPERACIÓN ",
      descripcion:
        "Le ofrecemos el mejor Sistema de Cobranza Judicial, proponiéndole el Sistema de Cobranza que más se ajuste a su realidad, tanto a la naturaleza del documento en cobranza como al proceso de la deuda desde que la obligación fue incumplida.",
      imagen: Creditos,
      icon: iconCreditos,
    },
    {
      titulo: "MINERO",
      subtitulo: "DERECHO",
      descripcion:
        "Brindamos asesoría integral en concesiones mineras, regulación ambiental y seguridad. Nuestro equipo experto en derecho minero acompaña a las empresas en todas las etapas, desde la exploración hasta la explotación, asegurando el cumplimiento normativo y la optimización de inversiones",
      imagen: Minero,
      icon: iconMinero,
    },
    {
      titulo: "PROCESAL LABORAL",
      subtitulo: "DERECHO LABORAL Y",
      descripcion:
        "Brindamos asesoría en compra-venta de bienes inmuebles, saneamiento de propiedades, contratos de arrendamiento y gestión de escrituras.",
      imagen: Procesal,
      icon: iconProcesal,
    },
  ];

  const posicionesCartas = [
    "servicio-0",
    "servicio-1",
    "servicio-2",
    "servicio-3",
    "servicio-4",
  ];

  const serviciosContables = [
    {
      titulo: "Declaración",
      subtitulo: "anual ",
      descripcion:
        "Preparamos la declaración anual de renta, asegurando el cumplimiento normativo y evitando errores o sanciones, brindando tranquilidad en las obligaciones tributarias.",
      icon: Respuesta,
    },
    {
      titulo: "planificación",
      subtitulo: "Tributaria",
      descripcion:
        "Optimizamos la carga tributaria mediante una revisión fiscal detallada, aprovechando incentivos y evitando sanciones. Brindamos respuesta rápida a notificaciones de SUNAT, asegurando cumplimiento normativo y protegiendo la rentabilidad del negocio.",
      icon: planificar,
    },
    {
      titulo: " a SUNAFIL y SUNAT",
      subtitulo: "Carta Respuesta",
      descripcion:
        "Brindamos un servicio integral de revisión y respuesta a notificaciones de SUNAT y SUNAFIL, redactando las cartas necesarias para garantizar cumplimiento, evitar sanciones y proteger a nuestros clientes.",
      icon: flechaDolar,
    },
    {
      titulo: "Mensual",
      subtitulo: "Declaración",
      descripcion:
        "Gestionamos las declaraciones mensuales de IGV-Renta, PDT-Plame y AFPnet, asegurando su presentación precisa y oportuna para cumplir con SUNAT y las obligaciones laborales ante la AFP.",
      icon: Calendario,
    },

    {
      titulo: "Reducción de",
      subtitulo: "Costos Tributarios",
      descripcion:
        "Reducimos costos tributarios mediante una revisión fiscal detallada, aprovechando incentivos y créditos, garantizando el cumplimiento legal. Brindamos respuesta rápida a notificaciones de SUNAT, minimizando la carga tributaria sin afectar el crecimiento ni la rentabilidad del negocio.",
      icon: Mensual,
    },
  ];

  return (
    <div className="contenedorGeneralServicios">
      <div className="contenedorConoceServicios">
        <h1>CONOCE NUESTROS SERVICIOS</h1>
        <p>
          En Torres y Torres, ofrecemos asesoría legal, servicios especializados
          en derecho y gestión contable. Nuestro equipo de expertos está listo
          para brindarte soluciones efectivas y seguras.
        </p>
      </div>

      <div className="serviciosGenerales">
        <div
          className="card-Service serviciosPrincipales"
          onClick={() => navigate("/servicios-generales")}
        >
          <Palacio />
          <h2>SERVICIOS GENERALES</h2>
        </div>

        <div
          className="card-Service ServiciosEspecializados"
          onClick={() => navigate("/servicios-especiales")}
        >
          <Balanza />
          <h2>SERVICIOS ESPECIALIZADOS</h2>
        </div>

        <div
          className="card-Service serviciosContables"
          onClick={() => navigate("/servicios-contables")}
        >
          <Contabilidad />
          <h2>SERVICIOS CONTABLES</h2>
        </div>
      </div>

      <div className="contendorCartasServicios">
        <div className="subtituloServiciosPag">
          <h2>NUESTROS SERVICIOS</h2>
          <div className="contenedorCartasServiciosPag">
            {servicios.map((servicio, index) => (
              <ServiciosGeneralesCard
                key={index}
                {...servicio}
                style={{ backgroundImage: `url(${servicio.imagen})` }}
              />
            ))}
          </div>
        </div>
      </div>
      <div className="contendorServiciosEspecializados">
        <div className="subtituloServiciosPag">
          <h4> NUESTROS SERVICIOS ESPECIALIZADOS</h4>
        </div>
        <div className="contenedorCartasEspecializadas">
          {serviciosEspecializados.map((servicio, index) => (
            <ServicioEspecializadoCard
              key={index}
              {...servicio}
              className={posicionesCartas[index % posicionesCartas.length]}
            />
          ))}
        </div>
        ;
      </div>
      <div className="contendorServiciosContables">
        <div className="subtituloServiciosPag">
          <h4> NUESTROS SERVICIOS CONTABLES</h4>
        </div>
        <div className="contenedorCartasContables">
          {serviciosContables.map((servicio, index) => (
            <ServiciosContablesCard key={index} {...servicio} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServiciosPag;
